<rlst-horizontal-scrollable-container>
  <i class="js-left-scroll-btn arrow-container far fa-chevron-left">
    <span class="sr-only">Scroll Left</span>
  </i>
  <div class="layer-data-wrapper">
    <div class="d-flex flex-shrink-0">
      <span class="layer-text text-nowrap">{{layerLabel}}:</span>
      <button class="btn-close d-md-none" (click)="closeLayer.emit()">
        <span class="sr-only">Close layer</span>
      </button>
    </div>
    <ul class="layer-wrapper list-unstyled m-0">
      <li class="layer-item align-items-center d-flex flex-nowrap flex-shrink-0" *ngFor="let rangeInfo of legendData">
        <span class="layer-color-block"
              aria-hidden="true"
              *ngIf="rangeInfo.color"
              [ngStyle]="{backgroundColor: rangeInfo.color}">
        </span>
        <span class="text-nowrap">{{rangeInfo.text}}</span>
      </li>
    </ul>
  </div>
  <button class="js-right-close-btn close-layer-btn btn-icon-primary" (click)="closeLayer.emit()">
    <i class="far fa-times" aria-hidden="true"></i>
    <span class="sr-only">Close layer</span>
  </button>
  <i class="js-right-scroll-btn arrow-container far fa-chevron-right">
    <span class="sr-only">Scroll Right</span>
  </i>
</rlst-horizontal-scrollable-container>
